































export default {
  props: {
    fieldSize: Number,
    minValue: Number,
    maxValue: Number,
    value: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    atMax() {
      return this.maxValue
        && parseInt(this.value, 10) >= this.maxValue;
    },
    atMin() {
      return this.minValue
        && parseInt(this.value, 10) <= this.minValue;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(value: string) {
        if (value && value < this.minValue) {
          // reset to minimum value if below minimum value
          this.$emit('input', this.minValue);
        } else if (value && value > this.maxValue) {
          // reset to maximum value if above maximum value
          this.$emit('input', this.maxValue);
        } else if (value && !isNaN(value as any)) {
          // convert to int if value is numeric
          this.$emit('input', parseInt(value, 10));
        }
      },
    },
  },
} as IView;
